export default __webpack_public_path__ + "static/aws-logo-white-780d529e1c08c7c647c397a876860bec.png";